import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, toRefs } from 'vue';
import { ChatGroup } from '@/models/Messenger';
import useMessengerState from '@/state/messenger/messengerState';
import BCXMessengerGroupCollapsible from '@/components/messenger/Group/BCXMessengerGroupCollapsible.vue';
import BCXMessengerChatGroupPreview from '@/components/messenger/ChatGroup/BCXMessengerChatGroupPreview.vue';
import withNewCount from '@/utils/withNewCount';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMessengerChatGroup',
  props: {
  group: {
    type: Object as PropType<ChatGroup>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { group } = toRefs(props);
const { openedGroupIDs, searchTerm, perGroupMeta } = useMessengerState();

const unreadCount = computed(() => perGroupMeta.value[group.value.groupId]?.unreadCount ?? 0);

const isOpened = computed<boolean>({
  get: () => !!searchTerm.value.length || openedGroupIDs.openedIds.includes(group.value.groupId),
  set: (state) => {
    if (state) {
      openedGroupIDs.openedIds.push(group.value.groupId);
    } else {
      openedGroupIDs.openedIds = openedGroupIDs.openedIds.filter((id: string) => id !== group.value.groupId);
    }
  }
});

return { __sfc: true,props, group, openedGroupIDs, searchTerm, perGroupMeta, unreadCount, isOpened, BCXMessengerGroupCollapsible, BCXMessengerChatGroupPreview, withNewCount }
}

})